import React from 'react';

import Pagination from '@material-ui/lab/Pagination';
import {makeStyles, createStyles} from '@material-ui/core/styles';
import {Box, Grid} from '@material-ui/core';

type Props = {
    page: number;
    totalPages: number;
    onChange: (value: number) => void;
};

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            '& > * + *': {
                marginTop: theme.spacing(2),
                justifyContent: 'center',
                display: 'flex',
            },
        },
    })
);

export default function EfePagination(props: Props) {
    const classes = useStyles();
    const {totalPages, onChange, page} = props;
    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        onChange(value);
    };


    return (
        <Grid item xs={12}>
            <Box display='flex' justifyContent='center'>
                <Pagination
                    className={classes.root}
                    count={totalPages}
                    page={page}
                    onChange={handleChange}
                />
            </Box>
        </Grid>
    );
}
